import { render, staticRenderFns } from "./page-software.vue?vue&type=template&id=ee2730f0"
import script from "./page-software.vue?vue&type=script&lang=js"
export * from "./page-software.vue?vue&type=script&lang=js"
import style0 from "./page-software.vue?vue&type=style&index=0&id=ee2730f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports